import { default as indexVQnU3vl6qrMeta } from "/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/pages/index.vue?macro=true";
import { default as linkTeamsBqO84SNsFWMeta } from "/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/pages/instructor/bootstrap/linkTeams.vue?macro=true";
import { default as loginDNCvZMkmbEMeta } from "/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/pages/instructor/bootstrap/login.vue?macro=true";
import { default as reconnecting6EogXulOtlMeta } from "/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/pages/instructor/bootstrap/reconnecting.vue?macro=true";
import { default as selectProgramwR4mRnQnYoMeta } from "/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/pages/instructor/bootstrap/selectProgram.vue?macro=true";
import { default as breakKl0EHl1vqIMeta } from "/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/pages/instructor/break.vue?macro=true";
import { default as endMlp6DoflbkMeta } from "/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/pages/instructor/end.vue?macro=true";
import { default as evaluation6YRXbLzNX8Meta } from "/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/pages/instructor/evaluation.vue?macro=true";
import { default as index9RPGCcvZtHMeta } from "/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/pages/instructor/index.vue?macro=true";
import { default as locationssM4hgw9SrPMeta } from "/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/pages/instructor/locations.vue?macro=true";
import { default as observeogvVHZ7OMiMeta } from "/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/pages/instructor/observe.vue?macro=true";
import { default as slideshowJrFDG9b4gCMeta } from "/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/pages/instructor/slideshow.vue?macro=true";
import { default as startszv3843DMOMeta } from "/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/pages/instructor/start.vue?macro=true";
import { default as waitKoUqQaVCuBMeta } from "/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/pages/instructor/wait.vue?macro=true";
import { default as slideshowstkBakJqlXbMeta } from "/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/pages/preview/slideshows.vue?macro=true";
import { default as selectModeKSowC5E1egMeta } from "/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/pages/selectMode.vue?macro=true";
import { default as enterCodefAN9rzh3k7Meta } from "/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/pages/team/bootstrap/enterCode.vue?macro=true";
import { default as reconnectingmpRo87c9O8Meta } from "/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/pages/team/bootstrap/reconnecting.vue?macro=true";
import { default as selectTeamHqzHIqB4xgMeta } from "/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/pages/team/bootstrap/selectTeam.vue?macro=true";
import { default as countdownjuNeIsXMuNMeta } from "/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/pages/team/cardGame/countdown.vue?macro=true";
import { default as indexp1QgU1ZKJ6Meta } from "/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/pages/team/cardGame/index.vue?macro=true";
import { default as questionqyOJeeiiFbMeta } from "/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/pages/team/cardGame/question.vue?macro=true";
import { default as questionOnScreenVNbYFE92MYMeta } from "/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/pages/team/cardGame/questionOnScreen.vue?macro=true";
import { default as endC8mDa2d293Meta } from "/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/pages/team/end.vue?macro=true";
import { default as index3tksPRpmKUMeta } from "/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/pages/team/index.vue?macro=true";
import { default as membersPdDjqNVKojMeta } from "/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/pages/team/members.vue?macro=true";
import { default as endSYv2KRH2WnMeta } from "/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/pages/team/observe/end.vue?macro=true";
import { default as executorgqmRzO8RunMeta } from "/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/pages/team/observe/executor.vue?macro=true";
import { default as indexuOUcSVnPrYMeta } from "/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/pages/team/observe/index.vue?macro=true";
import { default as judgeOYyC7lVzLpMeta } from "/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/pages/team/observe/judge.vue?macro=true";
import { default as observerTE1k5kaF8ZMeta } from "/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/pages/team/observe/observer.vue?macro=true";
import { default as roundsfCFXPgm1nNMeta } from "/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/pages/team/observe/rounds.vue?macro=true";
import { default as victimMxhBN3T3LEMeta } from "/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/pages/team/observe/victim.vue?macro=true";
import { default as slideshowOyzno9BfHAMeta } from "/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/pages/team/slideshow.vue?macro=true";
import { default as startLej4lvPYxNMeta } from "/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/pages/team/start.vue?macro=true";
import { default as toLocationf1QDkH17QMMeta } from "/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/pages/team/toLocation.vue?macro=true";
import { default as waitq17eX6BDGyMeta } from "/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/pages/team/wait.vue?macro=true";
import { default as slideshowsEya5w7ZeZKMeta } from "/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/pages/test/slideshows.vue?macro=true";
import { default as wakeLockmONCMxEIQzMeta } from "/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/pages/test/wakeLock.vue?macro=true";
import { default as webNotificationomzocCbpDHMeta } from "/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/pages/test/webNotification.vue?macro=true";
export default [
  {
    name: indexVQnU3vl6qrMeta?.name ?? "index___nl",
    path: indexVQnU3vl6qrMeta?.path ?? "/",
    meta: indexVQnU3vl6qrMeta || {},
    alias: indexVQnU3vl6qrMeta?.alias || [],
    redirect: indexVQnU3vl6qrMeta?.redirect || undefined,
    component: () => import("/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/pages/index.vue").then(m => m.default || m)
  },
  {
    name: linkTeamsBqO84SNsFWMeta?.name ?? "instructor-bootstrap-linkTeams___nl",
    path: linkTeamsBqO84SNsFWMeta?.path ?? "/instructor/bootstrap/linkTeams",
    meta: linkTeamsBqO84SNsFWMeta || {},
    alias: linkTeamsBqO84SNsFWMeta?.alias || [],
    redirect: linkTeamsBqO84SNsFWMeta?.redirect || undefined,
    component: () => import("/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/pages/instructor/bootstrap/linkTeams.vue").then(m => m.default || m)
  },
  {
    name: loginDNCvZMkmbEMeta?.name ?? "instructor-bootstrap-login___nl",
    path: loginDNCvZMkmbEMeta?.path ?? "/instructor/bootstrap/login",
    meta: loginDNCvZMkmbEMeta || {},
    alias: loginDNCvZMkmbEMeta?.alias || [],
    redirect: loginDNCvZMkmbEMeta?.redirect || undefined,
    component: () => import("/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/pages/instructor/bootstrap/login.vue").then(m => m.default || m)
  },
  {
    name: reconnecting6EogXulOtlMeta?.name ?? "instructor-bootstrap-reconnecting___nl",
    path: reconnecting6EogXulOtlMeta?.path ?? "/instructor/bootstrap/reconnecting",
    meta: reconnecting6EogXulOtlMeta || {},
    alias: reconnecting6EogXulOtlMeta?.alias || [],
    redirect: reconnecting6EogXulOtlMeta?.redirect || undefined,
    component: () => import("/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/pages/instructor/bootstrap/reconnecting.vue").then(m => m.default || m)
  },
  {
    name: selectProgramwR4mRnQnYoMeta?.name ?? "instructor-bootstrap-selectProgram___nl",
    path: selectProgramwR4mRnQnYoMeta?.path ?? "/instructor/bootstrap/selectProgram",
    meta: selectProgramwR4mRnQnYoMeta || {},
    alias: selectProgramwR4mRnQnYoMeta?.alias || [],
    redirect: selectProgramwR4mRnQnYoMeta?.redirect || undefined,
    component: () => import("/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/pages/instructor/bootstrap/selectProgram.vue").then(m => m.default || m)
  },
  {
    name: breakKl0EHl1vqIMeta?.name ?? "instructor-break___nl",
    path: breakKl0EHl1vqIMeta?.path ?? "/instructor/break",
    meta: breakKl0EHl1vqIMeta || {},
    alias: breakKl0EHl1vqIMeta?.alias || [],
    redirect: breakKl0EHl1vqIMeta?.redirect || undefined,
    component: () => import("/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/pages/instructor/break.vue").then(m => m.default || m)
  },
  {
    name: endMlp6DoflbkMeta?.name ?? "instructor-end___nl",
    path: endMlp6DoflbkMeta?.path ?? "/instructor/end",
    meta: endMlp6DoflbkMeta || {},
    alias: endMlp6DoflbkMeta?.alias || [],
    redirect: endMlp6DoflbkMeta?.redirect || undefined,
    component: () => import("/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/pages/instructor/end.vue").then(m => m.default || m)
  },
  {
    name: evaluation6YRXbLzNX8Meta?.name ?? "instructor-evaluation___nl",
    path: evaluation6YRXbLzNX8Meta?.path ?? "/instructor/evaluation",
    meta: evaluation6YRXbLzNX8Meta || {},
    alias: evaluation6YRXbLzNX8Meta?.alias || [],
    redirect: evaluation6YRXbLzNX8Meta?.redirect || undefined,
    component: () => import("/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/pages/instructor/evaluation.vue").then(m => m.default || m)
  },
  {
    name: index9RPGCcvZtHMeta?.name ?? "instructor___nl",
    path: index9RPGCcvZtHMeta?.path ?? "/instructor",
    meta: index9RPGCcvZtHMeta || {},
    alias: index9RPGCcvZtHMeta?.alias || [],
    redirect: index9RPGCcvZtHMeta?.redirect || undefined,
    component: () => import("/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/pages/instructor/index.vue").then(m => m.default || m)
  },
  {
    name: locationssM4hgw9SrPMeta?.name ?? "instructor-locations___nl",
    path: locationssM4hgw9SrPMeta?.path ?? "/instructor/locations",
    meta: locationssM4hgw9SrPMeta || {},
    alias: locationssM4hgw9SrPMeta?.alias || [],
    redirect: locationssM4hgw9SrPMeta?.redirect || undefined,
    component: () => import("/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/pages/instructor/locations.vue").then(m => m.default || m)
  },
  {
    name: observeogvVHZ7OMiMeta?.name ?? "instructor-observe___nl",
    path: observeogvVHZ7OMiMeta?.path ?? "/instructor/observe",
    meta: observeogvVHZ7OMiMeta || {},
    alias: observeogvVHZ7OMiMeta?.alias || [],
    redirect: observeogvVHZ7OMiMeta?.redirect || undefined,
    component: () => import("/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/pages/instructor/observe.vue").then(m => m.default || m)
  },
  {
    name: slideshowJrFDG9b4gCMeta?.name ?? "instructor-slideshow___nl",
    path: slideshowJrFDG9b4gCMeta?.path ?? "/instructor/slideshow",
    meta: slideshowJrFDG9b4gCMeta || {},
    alias: slideshowJrFDG9b4gCMeta?.alias || [],
    redirect: slideshowJrFDG9b4gCMeta?.redirect || undefined,
    component: () => import("/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/pages/instructor/slideshow.vue").then(m => m.default || m)
  },
  {
    name: startszv3843DMOMeta?.name ?? "instructor-start___nl",
    path: startszv3843DMOMeta?.path ?? "/instructor/start",
    meta: startszv3843DMOMeta || {},
    alias: startszv3843DMOMeta?.alias || [],
    redirect: startszv3843DMOMeta?.redirect || undefined,
    component: () => import("/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/pages/instructor/start.vue").then(m => m.default || m)
  },
  {
    name: waitKoUqQaVCuBMeta?.name ?? "instructor-wait___nl",
    path: waitKoUqQaVCuBMeta?.path ?? "/instructor/wait",
    meta: waitKoUqQaVCuBMeta || {},
    alias: waitKoUqQaVCuBMeta?.alias || [],
    redirect: waitKoUqQaVCuBMeta?.redirect || undefined,
    component: () => import("/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/pages/instructor/wait.vue").then(m => m.default || m)
  },
  {
    name: slideshowstkBakJqlXbMeta?.name ?? "preview-slideshows___nl",
    path: slideshowstkBakJqlXbMeta?.path ?? "/preview/slideshows",
    meta: slideshowstkBakJqlXbMeta || {},
    alias: slideshowstkBakJqlXbMeta?.alias || [],
    redirect: slideshowstkBakJqlXbMeta?.redirect || undefined,
    component: () => import("/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/pages/preview/slideshows.vue").then(m => m.default || m)
  },
  {
    name: selectModeKSowC5E1egMeta?.name ?? "selectMode___nl",
    path: selectModeKSowC5E1egMeta?.path ?? "/selectMode",
    meta: selectModeKSowC5E1egMeta || {},
    alias: selectModeKSowC5E1egMeta?.alias || [],
    redirect: selectModeKSowC5E1egMeta?.redirect || undefined,
    component: () => import("/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/pages/selectMode.vue").then(m => m.default || m)
  },
  {
    name: enterCodefAN9rzh3k7Meta?.name ?? "team-bootstrap-enterCode___nl",
    path: enterCodefAN9rzh3k7Meta?.path ?? "/team/bootstrap/enterCode",
    meta: enterCodefAN9rzh3k7Meta || {},
    alias: enterCodefAN9rzh3k7Meta?.alias || [],
    redirect: enterCodefAN9rzh3k7Meta?.redirect || undefined,
    component: () => import("/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/pages/team/bootstrap/enterCode.vue").then(m => m.default || m)
  },
  {
    name: reconnectingmpRo87c9O8Meta?.name ?? "team-bootstrap-reconnecting___nl",
    path: reconnectingmpRo87c9O8Meta?.path ?? "/team/bootstrap/reconnecting",
    meta: reconnectingmpRo87c9O8Meta || {},
    alias: reconnectingmpRo87c9O8Meta?.alias || [],
    redirect: reconnectingmpRo87c9O8Meta?.redirect || undefined,
    component: () => import("/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/pages/team/bootstrap/reconnecting.vue").then(m => m.default || m)
  },
  {
    name: selectTeamHqzHIqB4xgMeta?.name ?? "team-bootstrap-selectTeam___nl",
    path: selectTeamHqzHIqB4xgMeta?.path ?? "/team/bootstrap/selectTeam",
    meta: selectTeamHqzHIqB4xgMeta || {},
    alias: selectTeamHqzHIqB4xgMeta?.alias || [],
    redirect: selectTeamHqzHIqB4xgMeta?.redirect || undefined,
    component: () => import("/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/pages/team/bootstrap/selectTeam.vue").then(m => m.default || m)
  },
  {
    name: countdownjuNeIsXMuNMeta?.name ?? "team-cardGame-countdown___nl",
    path: countdownjuNeIsXMuNMeta?.path ?? "/team/cardGame/countdown",
    meta: countdownjuNeIsXMuNMeta || {},
    alias: countdownjuNeIsXMuNMeta?.alias || [],
    redirect: countdownjuNeIsXMuNMeta?.redirect || undefined,
    component: () => import("/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/pages/team/cardGame/countdown.vue").then(m => m.default || m)
  },
  {
    name: indexp1QgU1ZKJ6Meta?.name ?? "team-cardGame___nl",
    path: indexp1QgU1ZKJ6Meta?.path ?? "/team/cardGame",
    meta: indexp1QgU1ZKJ6Meta || {},
    alias: indexp1QgU1ZKJ6Meta?.alias || [],
    redirect: indexp1QgU1ZKJ6Meta?.redirect || undefined,
    component: () => import("/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/pages/team/cardGame/index.vue").then(m => m.default || m)
  },
  {
    name: questionqyOJeeiiFbMeta?.name ?? "team-cardGame-question___nl",
    path: questionqyOJeeiiFbMeta?.path ?? "/team/cardGame/question",
    meta: questionqyOJeeiiFbMeta || {},
    alias: questionqyOJeeiiFbMeta?.alias || [],
    redirect: questionqyOJeeiiFbMeta?.redirect || undefined,
    component: () => import("/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/pages/team/cardGame/question.vue").then(m => m.default || m)
  },
  {
    name: questionOnScreenVNbYFE92MYMeta?.name ?? "team-cardGame-questionOnScreen___nl",
    path: questionOnScreenVNbYFE92MYMeta?.path ?? "/team/cardGame/questionOnScreen",
    meta: questionOnScreenVNbYFE92MYMeta || {},
    alias: questionOnScreenVNbYFE92MYMeta?.alias || [],
    redirect: questionOnScreenVNbYFE92MYMeta?.redirect || undefined,
    component: () => import("/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/pages/team/cardGame/questionOnScreen.vue").then(m => m.default || m)
  },
  {
    name: endC8mDa2d293Meta?.name ?? "team-end___nl",
    path: endC8mDa2d293Meta?.path ?? "/team/end",
    meta: endC8mDa2d293Meta || {},
    alias: endC8mDa2d293Meta?.alias || [],
    redirect: endC8mDa2d293Meta?.redirect || undefined,
    component: () => import("/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/pages/team/end.vue").then(m => m.default || m)
  },
  {
    name: index3tksPRpmKUMeta?.name ?? "team___nl",
    path: index3tksPRpmKUMeta?.path ?? "/team",
    meta: index3tksPRpmKUMeta || {},
    alias: index3tksPRpmKUMeta?.alias || [],
    redirect: index3tksPRpmKUMeta?.redirect || undefined,
    component: () => import("/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/pages/team/index.vue").then(m => m.default || m)
  },
  {
    name: membersPdDjqNVKojMeta?.name ?? "team-members___nl",
    path: membersPdDjqNVKojMeta?.path ?? "/team/members",
    meta: membersPdDjqNVKojMeta || {},
    alias: membersPdDjqNVKojMeta?.alias || [],
    redirect: membersPdDjqNVKojMeta?.redirect || undefined,
    component: () => import("/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/pages/team/members.vue").then(m => m.default || m)
  },
  {
    name: endSYv2KRH2WnMeta?.name ?? "team-observe-end___nl",
    path: endSYv2KRH2WnMeta?.path ?? "/team/observe/end",
    meta: endSYv2KRH2WnMeta || {},
    alias: endSYv2KRH2WnMeta?.alias || [],
    redirect: endSYv2KRH2WnMeta?.redirect || undefined,
    component: () => import("/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/pages/team/observe/end.vue").then(m => m.default || m)
  },
  {
    name: executorgqmRzO8RunMeta?.name ?? "team-observe-executor___nl",
    path: executorgqmRzO8RunMeta?.path ?? "/team/observe/executor",
    meta: executorgqmRzO8RunMeta || {},
    alias: executorgqmRzO8RunMeta?.alias || [],
    redirect: executorgqmRzO8RunMeta?.redirect || undefined,
    component: () => import("/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/pages/team/observe/executor.vue").then(m => m.default || m)
  },
  {
    name: indexuOUcSVnPrYMeta?.name ?? "team-observe___nl",
    path: indexuOUcSVnPrYMeta?.path ?? "/team/observe",
    meta: indexuOUcSVnPrYMeta || {},
    alias: indexuOUcSVnPrYMeta?.alias || [],
    redirect: indexuOUcSVnPrYMeta?.redirect || undefined,
    component: () => import("/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/pages/team/observe/index.vue").then(m => m.default || m)
  },
  {
    name: judgeOYyC7lVzLpMeta?.name ?? "team-observe-judge___nl",
    path: judgeOYyC7lVzLpMeta?.path ?? "/team/observe/judge",
    meta: judgeOYyC7lVzLpMeta || {},
    alias: judgeOYyC7lVzLpMeta?.alias || [],
    redirect: judgeOYyC7lVzLpMeta?.redirect || undefined,
    component: () => import("/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/pages/team/observe/judge.vue").then(m => m.default || m)
  },
  {
    name: observerTE1k5kaF8ZMeta?.name ?? "team-observe-observer___nl",
    path: observerTE1k5kaF8ZMeta?.path ?? "/team/observe/observer",
    meta: observerTE1k5kaF8ZMeta || {},
    alias: observerTE1k5kaF8ZMeta?.alias || [],
    redirect: observerTE1k5kaF8ZMeta?.redirect || undefined,
    component: () => import("/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/pages/team/observe/observer.vue").then(m => m.default || m)
  },
  {
    name: roundsfCFXPgm1nNMeta?.name ?? "team-observe-rounds___nl",
    path: roundsfCFXPgm1nNMeta?.path ?? "/team/observe/rounds",
    meta: roundsfCFXPgm1nNMeta || {},
    alias: roundsfCFXPgm1nNMeta?.alias || [],
    redirect: roundsfCFXPgm1nNMeta?.redirect || undefined,
    component: () => import("/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/pages/team/observe/rounds.vue").then(m => m.default || m)
  },
  {
    name: victimMxhBN3T3LEMeta?.name ?? "team-observe-victim___nl",
    path: victimMxhBN3T3LEMeta?.path ?? "/team/observe/victim",
    meta: victimMxhBN3T3LEMeta || {},
    alias: victimMxhBN3T3LEMeta?.alias || [],
    redirect: victimMxhBN3T3LEMeta?.redirect || undefined,
    component: () => import("/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/pages/team/observe/victim.vue").then(m => m.default || m)
  },
  {
    name: slideshowOyzno9BfHAMeta?.name ?? "team-slideshow___nl",
    path: slideshowOyzno9BfHAMeta?.path ?? "/team/slideshow",
    meta: slideshowOyzno9BfHAMeta || {},
    alias: slideshowOyzno9BfHAMeta?.alias || [],
    redirect: slideshowOyzno9BfHAMeta?.redirect || undefined,
    component: () => import("/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/pages/team/slideshow.vue").then(m => m.default || m)
  },
  {
    name: startLej4lvPYxNMeta?.name ?? "team-start___nl",
    path: startLej4lvPYxNMeta?.path ?? "/team/start",
    meta: startLej4lvPYxNMeta || {},
    alias: startLej4lvPYxNMeta?.alias || [],
    redirect: startLej4lvPYxNMeta?.redirect || undefined,
    component: () => import("/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/pages/team/start.vue").then(m => m.default || m)
  },
  {
    name: toLocationf1QDkH17QMMeta?.name ?? "team-toLocation___nl",
    path: toLocationf1QDkH17QMMeta?.path ?? "/team/toLocation",
    meta: toLocationf1QDkH17QMMeta || {},
    alias: toLocationf1QDkH17QMMeta?.alias || [],
    redirect: toLocationf1QDkH17QMMeta?.redirect || undefined,
    component: () => import("/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/pages/team/toLocation.vue").then(m => m.default || m)
  },
  {
    name: waitq17eX6BDGyMeta?.name ?? "team-wait___nl",
    path: waitq17eX6BDGyMeta?.path ?? "/team/wait",
    meta: waitq17eX6BDGyMeta || {},
    alias: waitq17eX6BDGyMeta?.alias || [],
    redirect: waitq17eX6BDGyMeta?.redirect || undefined,
    component: () => import("/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/pages/team/wait.vue").then(m => m.default || m)
  },
  {
    name: slideshowsEya5w7ZeZKMeta?.name ?? "test-slideshows___nl",
    path: slideshowsEya5w7ZeZKMeta?.path ?? "/test/slideshows",
    meta: slideshowsEya5w7ZeZKMeta || {},
    alias: slideshowsEya5w7ZeZKMeta?.alias || [],
    redirect: slideshowsEya5w7ZeZKMeta?.redirect || undefined,
    component: () => import("/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/pages/test/slideshows.vue").then(m => m.default || m)
  },
  {
    name: wakeLockmONCMxEIQzMeta?.name ?? "test-wakeLock___nl",
    path: wakeLockmONCMxEIQzMeta?.path ?? "/test/wakeLock",
    meta: wakeLockmONCMxEIQzMeta || {},
    alias: wakeLockmONCMxEIQzMeta?.alias || [],
    redirect: wakeLockmONCMxEIQzMeta?.redirect || undefined,
    component: () => import("/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/pages/test/wakeLock.vue").then(m => m.default || m)
  },
  {
    name: webNotificationomzocCbpDHMeta?.name ?? "test-webNotification___nl",
    path: webNotificationomzocCbpDHMeta?.path ?? "/test/webNotification",
    meta: webNotificationomzocCbpDHMeta || {},
    alias: webNotificationomzocCbpDHMeta?.alias || [],
    redirect: webNotificationomzocCbpDHMeta?.redirect || undefined,
    component: () => import("/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/pages/test/webNotification.vue").then(m => m.default || m)
  }
]